import script from "./CategoryTag.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTag.vue?vue&type=script&setup=true&lang=js"

import "./CategoryTag.vue?vue&type=style&index=0&id=541f2504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541f2504"]])

export default __exports__